import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { PROPERTY } from "./apiRoutes";

const mutateAddProperty = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${PROPERTY(data.communityId)}`, data);
};

const useAddPropertyMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddProperty,
    ...queryParams,
  });

export default useAddPropertyMutation;
